import { defineMessages } from 'react-intl-next';
export let EditDateMessages = /*#__PURE__*/function (EditDateMessages) {
  EditDateMessages["DatePlaceholder"] = "DatePlaceholder";
  return EditDateMessages;
}({});
export const IntlEditDateMessages = defineMessages({
  [EditDateMessages.DatePlaceholder]: {
    id: 'form-system.DateQuestion.DatePlaceholder',
    defaultMessage: 'e.g. {date}'
  }
});